// Edge runtime entry point - uses WASM Sharp
import { edgeImageOps } from "../image/adapters/edge";

// Re-export all types and functions from the main index
export * from "../index";

// Override the image operations with Edge-specific implementation
import { imageOps } from "../index";
imageOps.svgToPng = edgeImageOps.svgToPng;
imageOps.isAvailable = edgeImageOps.isAvailable;
